export const EMPLOYEES = [
    // {
    //     name: "Ashley Palma",
    //     initials: "AP",
    //     role: "Senior Developer",
    //     employee_id: "EMP001",
    //     overall_progress: 65,
    //     milestone: "3/5",
    //     hours: "28/45h",
    //     details: {
    //         program: "Backend Architecture",
    //         status: "In Progress",
    //         metrics: {
    //             pre_score: 68,
    //             current: 76,
    //             target: 85,
    //             growth: 8
    //         },
    //         timeline: {
    //             start_date: "2025/01/15",
    //             target_end_date: "2025/04/15"
    //         },
    //         time_investment: {
    //             completed_hours: 28,
    //             total_hours: 45,
    //             progress_percent: 37.78
    //         },
    //         courses: [
    //             {
    //             course_name: "Advanced Microservices Architecture",
    //             status: "In Progress",
    //             course_progress_percent: 80,
    //             milestones: [
    //                     { name: "Microservices Fundamentals", due_date: "2025/01/22", completed_date: "2025/01/20", status: "Complete" },
    //                     { name: "Service Communication Patterns", due_date: "2025/01/29", completed_date: "2025/01/28", status: "Complete" },
    //                     { name: "Event-Driven Architecture", due_date: "2025/02/05", completed_date: "2025/02/04", status: "Complete" },
    //                     { name: "API Gateway Implementation", due_date: "2025/02/12", completed_date: "2025/02/10", status: "Complete" },
    //                     { name: "Final Project", due_date: "2025/02/19", completed_date: null, status: "Pending" }
    //                 ]
    //             },
    //             {
    //             course_name: "Cloud Infrastructure & Scalability",
    //             status: "In Progress",
    //             course_progress_percent: 50,
    //             milestones: [
    //                     { name: "Cloud Computing Basics", due_date: "2025/02/01", completed_date: "2025/01/30", status: "Complete" },
    //                     { name: "AWS/Azure Services", due_date: "2025/02/08", completed_date: "2025/02/07", status: "Complete" },
    //                     { name: "Auto-Scaling Strategies", due_date: "2025/02/15", completed_date: null, status: "Pending" },
    //                     { name: "Performance Optimization", due_date: "2025/02/22", completed_date: null, status: "Pending" }
    //                 ]
    //             }
    //         ]
    //     }
    // },
    // {
    //     name: "Saccharine Elupre",
    //     initials: "SE",
    //     role: "Marketing Manager",
    //     employee_id: "EMP002",
    //     overall_progress: 42,
    //     milestone: "2/6",
    //     hours: "22/60h",
    //     details: {
    //         program: "Digital Marketing Strategy",
    //         status: "In Progress",
    //         metrics: {
    //             pre_score: 62,
    //             current: 70,
    //             target: 82,
    //             growth: 8
    //         },
    //         timeline: {
    //             start_date: "2025/01/20",
    //             target_end_date: "2025/05/20"
    //         },
    //         time_investment: {
    //             completed_hours: 22,
    //             total_hours: 60,
    //             progress_percent: 36.67
    //         },
    //         courses: [
    //             {
    //             course_name: "Advanced SEO & Content Marketing",
    //             status: "In Progress",
    //             course_progress_percent: 60,
    //             milestones: [
    //                     { name: "SEO Fundamentals", due_date: "2025/01/27", completed_date: "2025/01/26", status: "Complete" },
    //                     { name: "Keyword Research Strategies", due_date: "2025/02/03", completed_date: "2025/02/02", status: "Complete" },
    //                     { name: "Content Marketing Best Practices", due_date: "2025/02/10", completed_date: null, status: "Complete" },
    //                     { name: "Link Building & Outreach", due_date: "2025/02/17", completed_date: null, status: "Pending" },
    //                     { name: "Analytics & Reporting", due_date: "2025/02/24", completed_date: null, status: "Pending" }
    //                 ]
    //             },
    //             {
    //             course_name: "Social Media Strategy & Analytics",
    //             status: "In Progress",
    //             course_progress_percent: 25,
    //             milestones: [
    //                     { name: "Platform Strategy Fundamentals", due_date: "2025/02/05", completed_date: "2025/02/04", status: "Complete" },
    //                     { name: "Audience Targeting & Personas", due_date: "2025/02/12", completed_date: null, status: "Pending" },
    //                     { name: "Engagement & Growth Tactics", due_date: "2025/02/19", completed_date: null, status: "Pending" },
    //                     { name: "ROI & Performance Analytics", due_date: "2025/02/26", completed_date: null, status: "Pending" }
    //                 ]
    //             }
    //         ]
    //     }
    // },
    // {
    //     name: "James Anderson",
    //     initials: "JA",
    //     role: "Customer Success Manager",
    //     employee_id: "EMP003",
    //     overall_progress: 88,
    //     milestone: "4/4",
    //     hours: "35/40h",
    //     details: {
    //         program: "Client Communication",
    //         status: "In Progress",
    //         metrics: {
    //             pre_score: 72,
    //             current: 86,
    //             target: 88,
    //             growth: 14
    //         },
    //         timeline: {
    //             start_date: "2025/01/05",
    //             target_end_date: "2025/03/05"
    //         },
    //         time_investment: {
    //             completed_hours: 35,
    //             total_hours: 40,
    //             progress_percent: 88
    //         },
    //         courses: [
    //             {
    //             course_name: "Effective Communication Skills",
    //             status: "Completed",
    //             course_progress_percent: 100,
    //             milestones: [
    //                 { name: "Active Listening", due_date: "2025/01/12", completed_date: "2025/01/11", status: "Complete" },
    //                 { name: "Persuasive Communication", due_date: "2025/01/19", completed_date: "2025/01/18", status: "Complete" },
    //                 { name: "Conflict Resolution", due_date: "2025/01/26", completed_date: "2025/01/25", status: "Complete" },
    //                 { name: "Presentation Skills", due_date: "2025/02/02", completed_date: "2025/02/01", status: "Complete" }
    //             ],
    //             completion_message: "Congratulations! All milestones achieved and recorded in the performance review system."
    //             },
    //             {
    //             course_name: "Customer Relationship Management",
    //             status: "In Progress",
    //             course_progress_percent: 75,
    //             milestones: [
    //                     { name: "CRM Fundamentals", due_date: "2025/02/08", completed_date: "2025/02/07", status: "Complete" },
    //                     { name: "Customer Retention Strategies", due_date: "2025/02/15", completed_date: "2025/02/14", status: "Complete" },
    //                     { name: "Upselling & Cross-selling", due_date: "2025/02/22", completed_date: "2025/02/21", status: "Complete" },
    //                     { name: "Customer Success Metrics", due_date: "2025/03/01", completed_date: null, status: "Pending" }
    //                 ]
    //             }
    //         ]
    //     }
    // }
];
